import { Grid } from '@mui/material';
import React, { Fragment, useRef, useState } from 'react';
import folder from '../../../assets/images/profile/folder.png';
import folder_lock from '../../../assets/images/profile/folder_lock.png';
import { CiLock, CiUnlock } from "react-icons/ci";
import { OverlayPanel } from 'primereact/overlaypanel';
import OverlayPanelContent from '../../../constants/AppPopover';
import { Customer } from '../../../helpers/models/Models';
import { EndBaseLine } from '../../../constants/AppSpace';
import { Button } from '../../../constants/Button';

interface CustomerListViewProps {
    data: {
        results: Customer[];
    } | null;
    loading: boolean;
    setOnURL: React.Dispatch<React.SetStateAction<string>>;
    refetch: () => void;
}

const ProfileListView: React.FC<CustomerListViewProps> = ({ data, refetch }) => {
    const overlayPanels = useRef<(OverlayPanel | null)[]>([]);
    const [activePanelIndex, setActivePanelIndex] = useState<number | null>(null);
    const [onLock, setOnLock] = useState<number | null>(null);
    const handleClick = (e: React.MouseEvent, index: number) => {
        const panel = overlayPanels.current[index];
        if (activePanelIndex === index) {
            panel?.toggle(e);
        } else {
            if (activePanelIndex !== null) {
                const previousPanel = overlayPanels.current[activePanelIndex];
                previousPanel?.hide();
            }
            setActivePanelIndex(index);
            panel?.toggle(e);
        }
    };

    return (
        <Fragment>
            <Grid container spacing={2}>
                {data?.results.map((user, index) => (
                    <Grid item lg={1} xl={1} md={1} xs={6} key={user.member_sn}>
                        <div className='relative hover:bg-gray-100 select-none py-2 transition-transform duration-300 ease-in-out rounded-sm text-center group'>
                            <div onClick={(e) => { setOnLock(user.member_sn); handleClick(e, index) }} className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out">
                                {user.profile_lock === 1 ? <CiLock className="w-4 h-4 cursor-pointer" /> : <CiUnlock className="w-4 h-4 cursor-pointer" />}
                            </div>
                            <div className="relative inline-block cursor-pointer" onClick={(e) => { handleClick(e, index); setOnLock(null); }}>
                                <img src={user.profile_lock === 1 ? folder_lock : folder} alt="" className="h-16" />
                            </div>
                            <OverlayPanel key={user.member_sn} ref={(el) => (overlayPanels.current[index] = el)}
                                className="custom-overlay-panel left-5">
                                <OverlayPanelContent key={user.member_sn} refetch={refetch}
                                    memberSN={user.member_sn}
                                    lock_unlock={onLock}
                                    name={user.mem_name}
                                    tole={user.tole_name || ""}
                                    phone={user.phone_no || ""}
                                    address={user.add_eng || ""}
                                    fatherName={user.father_name || ""}
                                    photo={user.photo || ""}
                                    lock_status={user.profile_lock || 0}
                                />
                            </OverlayPanel>
                            <h6 onClick={(e) => { handleClick(e, index); setOnLock(null); }} className='font-normal -mt-2 text-[12px] cursor-pointer dark:text-white'>{user.member_sn}. {user.mem_name}</h6>
                        </div>
                    </Grid>
                ))}

            </Grid>
            <EndBaseLine>
                <Button btn_type='prev' el='button' />
                <Button btn_type='next' el='button' />
            </EndBaseLine>
        </Fragment>
    );
};

export default ProfileListView;
